/** @jsxRuntime automatic */
/** @jsxImportSource react */
import { Component, type ErrorInfo, type ReactNode } from 'react';

// [The Lab] Resilience contract (Lab repo VISION §3.1): the testing widget must
// never hurt its host. This boundary wraps the lazy mount in App.tsx so a widget
// crash — or a failed load of its lazy chunk — is contained to the widget: it
// renders nothing, logs one console.debug line, and the admin console is
// unaffected. It deliberately sits INSIDE the app-wide Sentry boundary so a
// widget failure never trips the "Something went wrong — please reload" page.
export class LabWidgetBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  componentDidCatch(error: unknown, _info: ErrorInfo): void {
    try {
      console.debug('[lab-kit] widget hidden — it crashed:', error instanceof Error ? error.message : String(error));
    } catch {
      /* ignore */
    }
  }

  render(): ReactNode {
    return this.state.failed ? null : this.props.children;
  }
}
